/**
 * Internal dependencies
 */
import { Fish } from './fish';
import { OrderResponse, Restaurant } from './toast';
import { TicketedEventTicket } from './ticketedEvents';
import { EventBookingEvent } from './eventBooking';

export enum PaymentStatus {
  INITIATED = 'INITIATED',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

export enum DiscountType {
  PERCENTAGE = 'PERCENTAGE',
  FLATAMOUNT = 'FLATAMOUNT',
  PRICEOVERRIDE = 'PRICEOVERRIDE',
}

export enum PaymentType {
  DEPOSIT = 'DEPOSIT',
  PAYMENT = 'PAYMENT',
}

export type PaymentIntent = {
  id: string;
  fishId: string;
  toastId: string;
  status: PaymentStatus;
  createdAt: string;
  purchaseId: string | null;
  subscriptionId: string | null;
};

export type Payment = {
  id: string;
  fishId: string;
  paymentIntentId: string;
  paymentIntent?: PaymentIntent;
  toastTransactionId: string;
  status: PaymentStatus;
  responseMessage: string | null;
  createdAt: string;
  subscriptionId: string | null;
};

export type DeliveryAddress = {
  id?: string;
  streetAddress1?: string;
  streetAddress2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
};

export type Purchase = {
  id: string;
  fishId: string;
  fish?: Fish;
  status: PaymentStatus;
  price: number;
  originalPrice: number | null;
  discountAmount: number | null;
  discountType: DiscountType | null;
  productDescription: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  toastPaymentIntents?: PaymentIntent[];
  subscriptionId: string | null;
  order: OrderResponse | null;
  rawOrder: OrderResponse | null;
  deliveryAddress: DeliveryAddress | null;
  eventId: string | null;
  event?: EventBookingEvent;
  paymentType: PaymentType | null;
  confirmationNumber: string | null;
  restaurantDetails: Restaurant | null;
  ticketedEventTickets?: TicketedEventTicket[];
};
